export default "__VITE_ASSET__DQjKh025__"